export const blockIconsCommunicationCallNew = (
	<span className='material-symbols-outlined'>call</span>
);
